import React from "react"
import { Script } from "gatsby"
import { ApolloProvider } from '@apollo/react-hooks';
import client from './src/apollo/client';

export const wrapPageElement = ({ element }) => {
  return (

     <ApolloProvider client={client}>
      {element}
      <Script>
      {`
      window.$zoho=window.$zoho || {};$zoho.salesiq=$zoho.salesiq||{ready:function(){}}
      `}</Script>
    <Script id="zsiqscript"  strategy="idle" src="https://salesiq.zohopublic.com/widget?wc=siqc0ac90cd34572fd18f9d3390279d723e18406a286021cdb4b5d3bfb4fd152af4" defer></Script>
     </ApolloProvider>

  )
}
